import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { ChartOfAccountStyles } from "../Chart-Of-Account/ChartOfAccountShared";
import JournalCodeForm from "./JournalCodeForm";

const Edit = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const { id } = useParams();
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const res = await Http.get("/journal-code/" + id + "/edit");
        setInputs({
          code: res.data.code,
          name: res.data.name,
          remarks: res.data.remarks,
        });
      } catch (e) {
        console.error("Fetch error:", e);
        setError({
          load: [
            "Could not load this journal code. Please go back and try again.",
          ],
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    if (saving) {
      return;
    }

    setSaving(true);
    Http.put("/journal-code/" + id, inputs)
      .then((res) => {
        navigate("/journal-code", {
          state: { message: res.data.message, type: res.data.type },
        });
      })
      .catch((e) => {
        setSaving(false);
        setError(
          e.response?.data?.errors || {
            general: [
              e.response?.data?.message ||
                "Could not update the journal code. Please try again.",
            ],
          },
        );
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <ChartOfAccountStyles />
        <div className="am-pagetitle">
          <div>
            <h5 className="am-title mb-1">Edit Journal Code</h5>
            <p className="text-muted mb-0 tx-12">
              {inputs.name || `Journal code #${id}`}
            </p>
          </div>
          <div className="d-flex gap-2">
            <Link
              to={`/journal-code-ledger/${id}`}
              className="btn btn-outline-secondary"
            >
              <i className="fa fa-list mg-r-6"></i>Ledger
            </Link>
            <Link to="/journal-code" className="btn btn-outline-secondary">
              <i className="fa fa-arrow-left mg-r-6"></i>Back to List
            </Link>
          </div>
        </div>

        <div className="am-pagebody">
          <div className="row">
            <div className="col-lg">
              <FormValidation error={error} />
            </div>
          </div>

          {loading ? (
            <div className="coa-panel">
              <div className="coa-empty">
                <ProgressSpinner
                  style={{ width: "42px", height: "42px" }}
                  strokeWidth="6"
                />
              </div>
            </div>
          ) : (
            <JournalCodeForm
              inputs={inputs}
              onChange={handleChange}
              onSubmit={formSubmit}
              saving={saving}
              submitLabel="Update Journal Code"
              savingLabel="Updating..."
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Edit;
